import FlowTaker from 'FlowTaker/components/FlowTaker'
bindToDom('FlowTaker', FlowTaker)
